/**
 * Utility functions for safely handling regular expressions.
 * Prevents runtime errors like:
 *   "Invalid regular expression: Nothing to repeat"
 * when scanning job descriptions containing symbols (e.g., C++, A/B, Node.js).
 */

/**
 * Escapes all special regex characters in a string.
 * Example:
 *   escapeRegex("C++") → "C\\+\\+"
 */
export function escapeRegex(str = "") {
  return String(str).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/**
 * Creates a case-insensitive regex that matches a term safely inside text.
 * Works even with special characters and punctuation.
 *
 * Example:
 *   makeWordMatcher("C++").test("Experienced with C++ development")
 */
export function makeWordMatcher(term) {
  const safe = escapeRegex(term.trim());
  // Matches at start, end, or between non-word boundaries
  return new RegExp(`(^|\\W)${safe}(?=\\W|$)`, "gi");
}
